import type {Money} from '../money/typedef';

/**
 * @description Stringify Money object
 * @param {Money} value
 * @return {string} - that contains amount, currency, asOfDate values
 * @example
 * //returns '999 USD (2012-01-01)'
 * moneyToString({amount: 999, currency: 'USD', asOfDate: '2012-01-01'});
 */
const moneyToString = (value: Money): string => {
    const {amount, currency = ''} = value;
    const asOfDate = value.asOfDate ? `(${value.asOfDate})` : '';
    return `${amount} ${currency} ${asOfDate}`.trim();
};

export {moneyToString};
